import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../../apps/gs-2.0/src/environments/environment';

export interface TenantConfig {
  tenantId: string;
  tenantName: string;
  apiUrl: string;
  apiBaseUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private tenantConfig: TenantConfig;
  private tenantConfig$ = new BehaviorSubject<TenantConfig>(this.initializeTenantConfig());

  constructor() {
    this.tenantConfig = this.initializeTenantConfig();
  }

  private initializeTenantConfig(): TenantConfig {
    return {
      tenantId: environment.tenantId || 'default',
      tenantName: environment.tenantName || 'Default',
      apiUrl: environment.apiUrl,
      apiBaseUrl: environment.apiBaseUrl
    };
  }

  /**
   * Get the current tenant configuration
   */
  getTenantConfig(): TenantConfig {
    return this.tenantConfig;
  }

  /**
   * Get the current tenant configuration as an observable
   */
  getTenantConfig$(): Observable<TenantConfig> {
    return this.tenantConfig$.asObservable();
  }

  /**
   * Get the current tenant ID
   */
  getTenantId(): string {
    return this.tenantConfig.tenantId;
  }

  /**
   * Get the current tenant name
   */
  getTenantName(): string {
    return this.tenantConfig.tenantName;
  }

  /**
   * Check if the current tenant is a specific tenant
   */
  isTenant(tenantId: string): boolean {
    return this.tenantConfig.tenantId === tenantId;
  }

  /**
   * Get the tenant-specific API URL
   */
  getApiUrl(): string {
    return this.tenantConfig.apiUrl;
  }

  /**
   * Get the tenant-specific base API URL
   */
  getApiBaseUrl(): string {
    return this.tenantConfig.apiBaseUrl;
  }
}
